<!-- [モーダル] -->
<div
  #modalContents
  class="l-modal02__contents u-modal-size-pc-1000 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modalTitle"
>
  <div #modalHead class="l-modal02__header js-modal-head">
    <div class="p-modal-head02">
      <h1 id="modalTitle" class="p-modal-head02__title" [innerHTML]="'label.compareFare.title2' | staticMsg"></h1>
      <!-- 閉じるボタン -->
      <button id="head-modal-close" class="p-modal-head02__close js-modal-close" (click)="this.closeModal()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody class="l-modal02__body js-modal-body">
    <div class="p-cheapest-calendar">
      <div
        class="p-cheapest-calendar__inner js-cheapest-calendar"
        [ngClass]="{ 'is-scroll': isRightClicked || (!hideLeftBtn && isRightClicked) }"
      >
        <div class="p-cheapest-calendar__side">
          <div class="p-cheapest-calendar__side-head">
            <h2 class="p-cheapest-calendar__side-head-title" [innerHTML]="'label.outwardPathDepartureDate' | staticMsg">
              <!-- 表示中の往路選択可能期間 -->
              <span
                class="u-visually-hidden"
                [innerHTML]="
                  (selectedDepartureDate | dateFormat : 'default_departuredate') +
                  ('label.symbolBetweenTime' | staticMsg) +
                  (selectedReturnDate | dateFormat : 'default_departuredate')
                "
              >
              </span>
            </h2>
          </div>
          <!-- 往路日付リスト -->
          <div class="p-cheapest-calendar__side-body">
            <!-- 前の週ボタン -->
            <button
              *ngIf="this.showOutLastWeek"
              id="cheapest-calendar-side-before-btn"
              class="p-cheapest-calendar__side-arrow p-cheapest-calendar__side-arrow--top"
              [attr.aria-label]="'reader.beforeDays' | staticMsg"
              (click)="clickDepartPreviousWeek()"
            >
              <img src="assets/images/btn_arrow_up_primary_24.svg" width="24" height="24" aria-hidden="true" />
            </button>
            <!-- 次の週ボタン -->
            <button
              *ngIf="this.showOutNextWeek"
              id="cheapest-calendar-side-after-btn"
              class="p-cheapest-calendar__side-arrow p-cheapest-calendar__side-arrow--bottom"
              [attr.aria-label]="'reader.afterDays' | staticMsg"
              (click)="clickDepartNextWeek()"
            >
              <img src="assets/images/btn_arrow_down_primary_24.svg" width="24" height="24" aria-hidden="true" />
            </button>
            <!-- 往路出発日 -->
            <ng-container *ngFor="let departureDate of this.departureDateList; index as departureDateIndex">
              <div
                class="p-cheapest-calendar__side-week-cell"
                [id]="getDepartureDateId(departureDateIndex)"
                aria-hidden="true"
                [class.p-cheapest-calendar__side-week-cell--interval]="this.selectedRowIndex === departureDateIndex"
              >
                <span class="u-visually-hidden" [innerHTML]="'label.outwardPathDepartureDate' | staticMsg"></span>
                <!-- 日付・曜日 -->
                <p
                  class="p-cheapest-calendar__side-week-cell-date"
                  [innerHTML]="departureDate | dateFormat : 'departuredate_Matrix_SevenDaysCalendar'"
                ></p>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="p-cheapest-calendar__main">
          <div class="p-cheapest-calendar__main-head">
            <h2
              class="p-cheapest-calendar__main-head-title"
              [innerHTML]="'label.returnPathDepartureDate' | staticMsg"
            ></h2>
          </div>

          <!-- マトリクス形式7日間カレンダースクロールボタン(左) -->
          <ng-container *ngIf="!this.isPcDevice">
            <div
              class="p-cheapest-calendar__main-scroll p-cheapest-calendar__main-scroll--left"
              [ngClass]="{ 'is-active': isRightClicked || (!hideLeftBtn && isRightClicked) }"
            >
              <button
                id="cheapest-calendar-main-scroll-left-btn"
                class="p-cheapest-calendar__main-scroll-btn"
                (throttleClick$)="leftSlider()"
                aswThrottleClick
              >
                <img
                  src="assets/images/btn_arrow_prev_36.svg"
                  width="36"
                  height="36"
                  alt="{{ 'alt.switchToLeftScreen2' | staticMsg }}"
                />
              </button>
            </div>
          </ng-container>

          <!-- 復路日付リスト -->
          <asw-common-slider id="cheapest-calendar-matrix-modal-slider" [isCCMSlider]="true">
            <div class="p-cheapest-calendar__main-body" #scrollPanel>
              <div class="p-cheapest-calendar__main-body-week">
                <!-- 前の週ボタン -->
                <button
                  *ngIf="this.showReturnLastWeek"
                  id="cheapest-calendar-main-before-btn"
                  class="p-cheapest-calendar__main-arrow p-cheapest-calendar__main-arrow--left"
                  [attr.aria-label]="'reader.beforeDays' | staticMsg"
                  (click)="clickReturnPreviousWeek()"
                >
                  <img src="assets/images/btn_arrow_prev_primary_24.svg" width="24" height="24" aria-hidden="true" />
                </button>
                <!-- 次の週ボタン -->
                <button
                  *ngIf="this.showReturnNextWeek"
                  id="cheapest-calendar-main-after-btn"
                  class="p-cheapest-calendar__main-arrow p-cheapest-calendar__main-arrow--right"
                  [attr.aria-label]="'reader.afterDays' | staticMsg"
                  (click)="clickReturnNextWeek()"
                >
                  <img src="assets/images/btn_arrow_next_primary_24.svg" width="24" height="24" aria-hidden="true" />
                </button>
                <!-- 復路出発日 -->
                <ng-container *ngFor="let returnDate of this.returnDateList; index as returnDateIndex">
                  <div
                    #scrollItemList
                    class="p-cheapest-calendar__main-week-cell"
                    [id]="getReturnDateId(returnDateIndex)"
                    aria-hidden="true"
                    [class.p-cheapest-calendar__main-week-cell--interval]="this.selectedColIndex === returnDateIndex"
                  >
                    <span class="u-visually-hidden" [innerHTML]="'label.returnPathDepartureDate' | staticMsg"></span>
                    <!-- 日付・曜日 -->
                    <p
                      class="p-cheapest-calendar__main-week-cell-date"
                      [innerHTML]="returnDate | dateFormat : 'departuredate_Matrix_SevenDaysCalendar'"
                    ></p>
                  </div>
                </ng-container>
              </div>

              <!-- マトリクス形式7日間カレンダー選択リスト -->
              <div class="p-cheapest-calendar__main-body-data js-plan-table01" role="grid">
                <!-- 往復組み合わせ日付 往路⇒復路のマトリクスを２重ループで生成 -->
                <!-- 行(往路出発日)のループ -->
                <ng-container *ngFor="let airCalendarRow of this.airCalendarCellList; index as rowIndex">
                  <div class="p-cheapest-calendar__main-row" role="row">
                    <!-- 列(復路出発日)のループ -->
                    <ng-container *ngFor="let airCalendarCell of airCalendarRow; index as colIndex">
                      <!-- interval:選択中日付と同行・同列、selected:選択中セル、 not:利用不可-->
                      <div
                        class="p-cheapest-calendar__main-cell"
                        role="gridcell"
                        [class.p-cheapest-calendar__main-cell--interval]="
                          this.selectedRowIndex >= rowIndex &&
                          this.selectedColIndex >= colIndex &&
                          !(this.selectedRowIndex !== rowIndex && this.selectedColIndex !== colIndex)
                        "
                        [class.p-cheapest-calendar__main-cell--selected]="
                          this.selectedRowIndex === rowIndex && this.selectedColIndex === colIndex
                        "
                        [class.p-cheapest-calendar__main-cell--not]="
                          airCalendarCell.isDisplay && !airCalendarCell.isAvaliable
                        "
                      >
                        <!-- 表示対象の場合描画 -->
                        <ng-container *ngIf="airCalendarCell.isDisplay">
                          <button
                            id="cheapest-calendar-cell-{{ rowIndex }}-{{ colIndex }}-btn"
                            class="p-cheapest-calendar__main-cell-inner"
                            [disabled]="!airCalendarCell.isAvaliable"
                            [attr.aria-pressed]="
                              this.selectedRowIndex === rowIndex && this.selectedColIndex === colIndex
                            "
                            (throttleClick$)="this.selectDate($event, rowIndex, colIndex)"
                            aswThrottleClick
                          >
                            <span
                              [attr.aria-labelledby]="getDepartureDateId(rowIndex) + ' ' + getReturnDateId(colIndex)"
                            ></span>
                            <ng-container *ngIf="airCalendarCell.isLowestPrice">
                              <span class="p-cheapest-calendar__main-cell-tag">
                                <span
                                  class="c-tag-lowest-price c-tag-lowest-price--s"
                                  [innerHTML]="'label.lowestprice1' | staticMsg"
                                ></span>
                              </span>
                            </ng-container>
                            <span class="p-cheapest-calendar__main-cell-price">
                              <ng-container *ngIf="airCalendarCell.isAvaliable">
                                <span
                                  class="p-cheapest-calendar__main-cell-price-num"
                                  [innerHTML]="airCalendarCell.price | amountFormat : 'cheapestCalendar_totalPrice'"
                                ></span>
                              </ng-container>
                              <ng-container *ngIf="!airCalendarCell.isAvaliable">
                                {{ 'label.unselectable' | staticMsg }}
                              </ng-container>
                            </span>
                          </button>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
                <!-- 行(往路出発日)のループここまで -->
              </div>
            </div>
          </asw-common-slider>

          <!-- マトリクス形式7日間カレンダースクロールボタン(右) -->
          <ng-container *ngIf="!this.isPcDevice">
            <div
              class="p-cheapest-calendar__main-scroll p-cheapest-calendar__main-scroll--right"
              [ngClass]="{ 'is-active': !hideRightBtn }"
            >
              <button
                id="cheapest-calendar-main-scroll-right-btn"
                class="p-cheapest-calendar__main-scroll-btn"
                (throttleClick$)="rightSlider()"
                aswThrottleClick
              >
                <img
                  src="assets/images/btn_arrow_next_36.svg"
                  width="36"
                  height="36"
                  alt="{{ 'alt.switchToRightScreen2' | staticMsg }}"
                />
              </button>
            </div>
          </ng-container>
        </div>
        <!-- [p-cheapest-calendar__main] -->
      </div>
    </div>
    <!-- [p-cheapest-calendar] -->
  </div>

  <!-- モーダルフッター部 -->
  <div #modalFooter class="l-modal02__footer is-shadow js-modal-footer">
    <div class="p-modal-foot02">
      <div class="p-modal-foot02__content">
        <!-- 選択中往路出発日 -->
        <!-- 選択中復路出発日 -->
        <div
          class="p-modal-foot02__content-date"
          [innerHTML]="
            (this.selectedDepartureDate | dateFormat : 'default_departuredate') +
            ('label.symbolBetweenTime' | staticMsg) +
            (this.selectedReturnDate | dateFormat : 'default_departuredate')
          "
        ></div>
        <div class="p-modal-foot02__content-price">
          <!-- 選択中支払総額 -->
          <span
            class="p-modal-foot02__content-price-num"
            [innerHTML]="this.selectedPrice | amountFormat : 'cheapestCalendar_selected.totalPrice'"
          ></span>
          <span
            class="p-modal-foot02__content-price-text"
            [innerHTML]="'label.passenger1' | staticMsg : { '0': this.totalTravelers }"
          ></span>
        </div>
      </div>
      <div class="p-modal-foot02__content">
        <!-- 次へボタン -->
        <button
          id="proceed-btn"
          class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
          (click)="this.applyModal()"
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.proceed' | staticMsg"></span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- //[モーダル] -->
